import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useBillingDictTypes = () => {
    const {t} = useTwinTranslation()
    const dictTypeBilling: TwinDictionary = {
        0: { name: t('supplier', 'Proveedor') },
        1: { name: t('autoinvoice', 'Autofactura') },
        2: { name: t('supplierHeredate', 'Proveedor (Heredar)') }
    }
    const dictImportType: TwinDictionary = {
        0: { name: t('notImport', 'No importación') },
        1: { name: t('import', 'Importación') },
        2: { name: t('notImportHeredate', 'No importación (Heredar)') }
    }
    const dictRetentionType: TwinDictionary = {
        0: { name: t('notRetention', 'Sin retención') },
        1: { name: t('retention', 'Retención') },
        2: { name: t('notRetentionHeredate', 'Sin retención (Heredar)') }
    }
    const dictVatSupportedType: TwinDictionary = {
        0: { name: t('withVat', 'Con IVA') },
        1: { name: t('withoutVat', 'Sin IVA') },
        2: { name: t('withVatHeredate', 'Con IVA (Heredar)') }
    }
    const dictExportType: TwinDictionary = {
        0: { name: t('notExport', 'No exportación') },
        1: { name: t('export', 'Exportación') },
        2: { name: t('notExportHeredate', 'No exportación (Heredar)') }
    }
    return { dictTypeBilling, dictImportType, dictRetentionType, dictVatSupportedType, dictExportType }
}

export default useBillingDictTypes